/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IOasParameterParent } from '../../openapi/models/IOasParameterParent';
import { OasParameter } from '../../openapi/models/OasParameter';

/**
 * A command used to delete all parameters from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllParametersCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _paramType : string;

    public _oldParams : Array<any>;

    public constructor(parent? : any, type? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasParameterParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasParameterParent") >= 0)) || parent === null) && ((typeof type === 'string') || type === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._oldParams===undefined) this._oldParams = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._oldParams===undefined) this._oldParams = null;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
                this._paramType = type;
            })();
        } else if(parent === undefined && type === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._oldParams===undefined) this._oldParams = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._oldParams===undefined) this._oldParams = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllParameters] Executing.");
        this._oldParams = <any>([]);
        let parent : IOasParameterParent = <IOasParameterParent><any>this._parentPath.resolve(document);
        let parameters : Array<OasParameter> = parent.getParameters();
        if(this.isNullOrUndefined(parent) || this.isNullOrUndefined(parameters) || /* size */(<number>parameters.length) === 0) {
            return;
        }
        let paramsToRemove : Array<OasParameter> = <any>([]);
        for(let index204=0; index204 < parameters.length; index204++) {
            let param = parameters[index204];
            {
                if(NodeCompat.equals(param.in, this._paramType)) {
                    /* add */(this._oldParams.push(Library.writeNode(param))>0);
                    /* add */(paramsToRemove.push(param)>0);
                }
            }
        }
        if(/* size */(<number>this._oldParams.length) === 0) {
            return;
        }
        paramsToRemove.forEach(((parameters) => {
            return (paramToRemove) => {
                /* remove */(a => { let index = a.indexOf(paramToRemove); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(parameters);
            }
        })(parameters));
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllParameters] Reverting.");
        if(this.isNullOrUndefined(this._oldParams) || /* size */(<number>this._oldParams.length) === 0) {
            return;
        }
        let parent : IOasParameterParent = <IOasParameterParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        this._oldParams.forEach(((parent) => {
            return (param) => {
                let p : OasParameter = parent.createParameter();
                Library.readNode(param, p);
                parent.addParameter(p);
            }
        })(parent));
    }
}
DeleteAllParametersCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllParametersCommand";
DeleteAllParametersCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

